import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="w-full py-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-137">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-2xl w-full" data-id="element-138">
        <div className="rounded-2xl p-8 sm:p-12 flex flex-col items-center text-center relative overflow-hidden" style={{
        background: 'linear-gradient(160deg, #0a0f2e 0%, #0d1540 40%, #101840 60%, #0a0f2e 100%)',
        border: '1px solid rgba(0, 212, 255, 0.2)',
        boxShadow: '0 0 60px rgba(0,212,255,0.06), 0 0 120px rgba(0,212,255,0.02), 0 20px 60px rgba(0,0,0,0.4)'
      }} data-id="element-139">
          {/* Corner accents */}
          <div className="absolute top-0 right-0 w-40 h-40 opacity-[0.06] pointer-events-none" style={{
          background: 'radial-gradient(circle at top right, #00D4FF, transparent 70%)'
        }} data-id="element-140" />
          <div className="absolute bottom-0 left-0 w-40 h-40 opacity-[0.04] pointer-events-none" style={{
          background: 'radial-gradient(circle at bottom left, #00D4FF, transparent 70%)'
        }} data-id="element-141" />

          {/* Shield badge */}
          <motion.div initial={{
          scale: 0,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="w-20 h-20 rounded-full flex items-center justify-center mb-6" style={{
          background: 'radial-gradient(circle at 30% 30%, rgba(0,212,255,0.15), rgba(0,212,255,0.05) 70%)',
          border: '1.5px solid rgba(0,212,255,0.25)',
          boxShadow: '0 0 30px rgba(0,212,255,0.1), 0 0 60px rgba(0,212,255,0.04)'
        }} data-id="element-142">
            <span className="text-4xl" style={{
            filter: 'drop-shadow(0 0 8px rgba(0,212,255,0.3))'
          }} data-id="element-143">
              🛡️
            </span>
          </motion.div>

          <div className="text-brand-cyan text-[10px] font-bold tracking-[0.3em] uppercase mb-3" style={{
          textShadow: '0 0 10px rgba(0,212,255,0.3)'
        }} data-id="element-144">
            GARANTÍA BLINDADA
          </div>

          <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-3 tracking-tight" data-id="element-145">
            7 Días. <span className="text-brand-cyan" data-id="element-146">Riesgo Cero.</span>
          </h2>

          <p className="text-gray-400 text-sm sm:text-base mb-8 max-w-md leading-relaxed" data-id="element-147">
            Probá todo el MegaPack durante una semana completa. Si no es lo que
            esperabas, te devolvemos{' '}
            <span className="text-white font-semibold" data-id="element-148">
              el 100% de tu dinero
            </span>
            . Sin preguntas. Sin vueltas.
          </p>

          {/* Compact trust indicators */}
          <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-149">
            <div className="flex items-center gap-2 px-4 py-2 rounded-full text-xs font-medium text-gray-300" style={{
            background: 'rgba(34,197,94,0.06)',
            border: '1px solid rgba(34,197,94,0.15)'
          }} data-id="element-150">
              <span className="text-green-400 text-sm" data-id="element-151">✓</span>
              Reembolso completo
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-full text-xs font-medium text-gray-300" style={{
            background: 'rgba(34,197,94,0.06)',
            border: '1px solid rgba(34,197,94,0.15)'
          }} data-id="element-152">
              <span className="text-green-400 text-sm" data-id="element-153">✓</span>
              Sin preguntas
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-full text-xs font-medium text-gray-300" style={{
            background: 'rgba(34,197,94,0.06)',
            border: '1px solid rgba(34,197,94,0.15)'
          }} data-id="element-154">
              <span className="text-green-400 text-sm" data-id="element-155">✓</span>
              Acceso total 7 días
            </div>
          </div>

          <p className="text-white font-bold text-base sm:text-lg mb-7 max-w-sm" style={{
          textShadow: '0 0 15px rgba(255,255,255,0.05)'
        }} data-id="element-156">
            El único riesgo real es no proteger tu cuenta{' '}
            <span className="text-red-400" data-id="element-157">esta noche</span>.
          </p>

          <motion.button whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} className="w-full max-w-sm bg-green-500 hover:bg-green-600 text-black font-extrabold text-base py-4 px-6 rounded-xl transition-all uppercase tracking-wide" style={{
          boxShadow: '0 0 30px rgba(34,197,94,0.25), 0 4px 15px rgba(0,0,0,0.3)'
        }} data-id="element-158">
            Quiero probarlo sin riesgo →
          </motion.button>
        </div>
      </motion.div>
    </section>;
}